import {
    ITSUserData, TerritoryBudgetData, UploadResponseModel, UploadRequestModel,
    DeleteObjectModel, QuotaInputData,DetailedQuotaData,StaffSecurityRoleData,
    RolePlanTypeMappingData, RolePayCurveMappingData
} from "./../models/cm-model";
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'

@Injectable()
export class CapacityModelService {
    baseurl: string = environment.baseurl;
    apiKey: string = environment.APIKey;
    baseTokenurl: string = environment.baseTokenurl;
    userData = new ITSUserData();
    token: string = "";
    tokenDetails: any;
    localfiscalyear: any;
    //   public requestOptions!: RequestOptions;
    constructor(private http: HttpClient) {
        // this.tokenDetails = JSON.parse(localStorage.getItem("tokenDetails"));
        // this.CheckAccess(this.tokenDetails);
    }

    // Getterritorytest() {
    // this.http
    //     .post(this.baseurl + "postdatas?resourcename=updateterritorybudgets&fiscalyear=FY20SY", "{\"test\":\"value1\"}", { observe: 'response' })
    //     .subscribe(responsedata => console.log(responsedata));
    // this.http.get<any>("https://cnh59c0f20.execute-api.us-east-1.amazonaws.com/dev/getdatas", { observe: 'body' })
    //     .subscribe(responsedata => console.log(responsedata.Result));
    // this.http
    //     .get(this.baseurl + "upload?resourcename=updateterritorybudgets&fiscalyear=FY20SY&uploadtypeid=1000&userlogin=rameshbabu.kollu@infor.com")
    //     .subscribe(responsedata => console.log(responsedata));
    // this.http.get<any>("https://cnh59c0f20.execute-api.us-east-1.amazonaws.com/dev/getdata?fiscalyear=FY20SY&resourcename=getterritorybudgets", { observe: 'response' })
    //     .subscribe(responsedata => console.log(responsedata));
    // this.http.get<any>("https://cnh59c0f20.execute-api.us-east-1.amazonaws.com/dev/getdata?fiscalyear=FY20SY&resourcename=getterritorybudgets", { observe: 'body' })
    //     .subscribe(responsedata => console.log(JSON.parse(responsedata.body).Result));
    //}
    GetManualGicQuotas(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+ localfiscalyear +"&resourcename=getmanualquotas&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetTerritoryBudgetsData(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+ localfiscalyear +"&resourcename=getterritorybudgets&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetUploadRequests(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+localfiscalyear+"&resourcename=getuploadrequests&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetManualUploadRequests(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+localfiscalyear+"&resourcename=getmanualuploadrequests&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetDetailedQuotasData(EmailAddress: string): Observable<any> {
        
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+localfiscalyear+"&resourcename=getdetailedquotas&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetQuotaInputs(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+localfiscalyear+"&resourcename=getquotainputs&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetQuotaInputsSubmitted(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+localfiscalyear+"&resourcename=getquotassubmitted&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetS3PresignedURL(requestObj: UploadRequestModel): Observable<any> {
        return this.http
            .get(this.baseurl + "upload?fiscalyear=" + requestObj.fiscalyear + "&uploadtypeid=" + requestObj.uploadtypeid + "&userlogin=" + requestObj.userlogin , { observe: 'response' })
            .pipe(map((responsedata => { return responsedata })));
    }
    PostUploadFile(model: UploadResponseModel): Observable<any> {
        return this.http
            .put(model.PresignedURL, model.FileToUpload, { headers: { 'Content-Type': "text/csv" } })
            .pipe(map(
                res => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    DeleteTerritoryBudgets(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "deletedatas?resourcename=deleteterritorybudgets&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    DeleteDetailedQuotas(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "deletedatas?resourcename=deletedetailedquotas&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    DeleteFinalizedQuotas(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "deletedatas?resourcename=deletefinalizedquotas&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    DeleteQuotaInputs(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "deletedatas?resourcename=deletequotainputs&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    GetFinilizedQuotasData(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+localfiscalyear+"&resourcename=getfinalizedquotas&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    CreateFinalQuotaList(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=createfinalquotalist&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    CreateQuotApprovalRequest(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=approvefinalquotas&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    SubmitQuotasToGIC(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=submitquotastogic&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    MoveQuotasBacktoReview(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=movequotasbacktoreview&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }

    RejectQuotaInputs(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=rejectquotainputs&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    GetPreSignedUrls(model: any[]): Observable<any> {
        
        var data = JSON.stringify(model);
        return this.http
            .post(this.baseurl +  "postdatas?resourcename=getpresignedurls&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }

    DeleteManualUpload(model: any[]) : Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
           .post(this.baseurl + "postdatas?resourcename=deletemanualupload&fiscalyear="+this.localfiscalyear, data)
           .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    ArchiveSelectedFiles(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=archivefiles&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }

    CreatePlansForTheSelectedQuotas(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=addquotastoits&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    // GetCapacityModelsData(resource: string): Observable<any> {
    //     return this.http
    //         .get<any>(this.baseurl + resource, { observe: 'body' })
    //         .pipe(map(response => {
    //             return JSON.parse(response.body['body'])['Result']
    //         }));
    // }

    GetTerritoryBudgetForEdit(UniqueID: string): Observable<any> {
        return this.http
            .get<any>(this.baseurl + "getdatas?resourcename=getsingleterritorybudget&fiscalyear="+this.localfiscalyear+"&uniqueid=" + UniqueID)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetQuotaInputForEdit(UniqueID: string): Observable<any> {
        return this.http
            .get<any>(this.baseurl + "getdatas?resourcename=getsinglequotainput&fiscalyear="+this.localfiscalyear+"&uniqueid=" + UniqueID)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetUserRole(EmailAddress: string): Observable<any> {
        console.log(this.baseurl);
        return this.http
            .get<any>(this.baseurl + "getdatas?resourcename=getrole&fiscalyear="+this.localfiscalyear+"&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    ActivateLambda(): Observable<any> {
        return this.http
            .get<any>(this.baseurl + "getdatas?resourcename=activate&fiscalyear="+this.localfiscalyear)
            .pipe(map(response => {
                return response;
            }));
    }
    GetDetailedQuotaForEdit(UniqueID: string, EmailAddress: string): Observable<any> {
        return this.http
            .get<any>(this.baseurl + "getdatas?resourcename=getsingledetailedquota&fiscalyear="+this.localfiscalyear+"&uniqueid=" + UniqueID + "&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    GetQuotaInputSubmittedForEdit(UniqueID: string, EmailAddress: string): Observable<any> {
        return this.http
            .get<any>(this.baseurl + "getdatas?resourcename=getsinglequotasubmitted&fiscalyear="+this.localfiscalyear+"&uniqueid=" + UniqueID + "&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    UpdateTerritoryBudgets(model: TerritoryBudgetData): Observable<any> {

        var headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Headers', 'X-Requested-With,Content-Type');
        headers.append('Access-Control-Allow-Methods', 'OPTIONS,POST,GET,DELETE');
        headers.append('Access-Control-Allow-Origin', 'localhost');
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=updatesingleterritorybudget&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    UpdateQuotaInputs(model: QuotaInputData): Observable<any> {

        var headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Headers', 'X-Requested-With,Content-Type');
        headers.append('Access-Control-Allow-Methods', 'OPTIONS,POST,GET,DELETE');
        headers.append('Access-Control-Allow-Origin', 'localhost');
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=updatesinglequotainput&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    UpdateDetailedQuotas(model: DetailedQuotaData): Observable<any> {
        var headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Headers', 'X-Requested-With,Content-Type');
        headers.append('Access-Control-Allow-Methods', 'OPTIONS,POST,GET,DELETE');
        headers.append('Access-Control-Allow-Origin', 'localhost');
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=updatesingledetailedquota&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    //this.Getterritory();
    // return this.http
    // .get<any>(this.baseurl + "territorybudgets", { observe: 'body' })
    // .pipe(map(response => { 
    // const territorybudgets1: TerritoryBudgetData[] = response.body.Result;
    //     console.log(territorybudgets1);
    //return response.Result;
    //}));
    // return this.http.get<TerritoryBudgetData[]>(
    //     "https://oy6apaevzh.execute-api.us-east-1.amazonaws.com/developement/territorybudgets", { observe: 'response' })
    //     .pipe(
    //         map(responseData => {
    //             // const territorybudgets1: TerritoryBudgetData[] = responseData.body.Result;
    //             // console.log(territorybudgets1[0]);
    //             // const territorybudgets: TerritoryBudgetData[] = JSON.parse(responseData.body['body'])['Result'];
    //             // return territorybudgets1;
    //             return responseData;
    //         }
    //         ));
    //}
    // GetTerritoryBudgets(): Observable<TerritoryBudgetData[]> {
    //     //const headers = new HttpHeaders().set("Access-Control-Allow-Origin","*");
    //     this.getConfigResponse()
    //         .pipe(map((responsedata) => { return JSON.parse(responsedata.body['body'])['Result'] }))
    //         .subscribe(resp => console.log(resp));

    //     this.http.get(this.baseurl + "territorywithoutproxy", { observe: 'body' }).subscribe(response => console.log(response));

    //     return this.http
    //         .get<TerritoryBudgetData[]>(this.baseurl + "territorywithoutproxy", { responseType: 'json', observe: 'body' })
    //         .pipe(map(response => { return response }));
    // }
    CrateApplicationAccess(model: StaffSecurityRoleData): Observable<any> {
        var data = JSON.stringify(model);
        //console.log(data);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=newstaffuser&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    //console.log(res);
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    GetAccessDetails(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+localfiscalyear+"&resourcename=getaccessdetails&userlogin=" + EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }  
    GetAccessDetailsforSigle(uniqueID: string): Observable<any> {
        return this.http
            .get<any>(this.baseurl + "getdatas?resourcename=getaccessdetailsforsingle&fiscalyear="+this.localfiscalyear+"&uniqueid=" +uniqueID)
            .pipe(map(response => {
                return response.Result;
            }));
    }
    DeactiveUser(model:StaffSecurityRoleData): Observable<any> {
        var headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Headers', 'X-Requested-With,Content-Type');
        headers.append('Access-Control-Allow-Methods', 'OPTIONS,POST,GET,DELETE');
        headers.append('Access-Control-Allow-Origin', 'localhost');
        var data = JSON.stringify(model);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=userstatusupdate&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(  
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    UpdateAcessDetails(model:StaffSecurityRoleData): Observable<any> {
        var headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Headers', 'X-Requested-With,Content-Type');
        headers.append('Access-Control-Allow-Methods', 'OPTIONS,POST,GET,DELETE');
        headers.append('Access-Control-Allow-Origin', 'localhost');
        var data = JSON.stringify(model);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=updateaceessdetails&fiscalyear="+this.localfiscalyear, data)
            .pipe(map(  
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
          ) );
    }
    GetArchiveFiles(EmailAddress: string): Observable<any> {
        let localfiscalyear = localStorage.getItem("fiscalyear")!? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<any>(this.baseurl + "getdatas?fiscalyear="+ localfiscalyear +"&resourcename=getarchivefilesdata&userlogin="+ EmailAddress)
            .pipe(map(response => {
                return response.Result;
            }));
    }

    ArchivedFileComments(model): Observable<any> {
        var headers = new HttpHeaders();
        headers.append('Access-Control-Allow-Headers', 'X-Requested-With,Content-Type');
        headers.append('Access-Control-Allow-Methods', 'OPTIONS,POST,GET,DELETE');
        headers.append('Access-Control-Allow-Origin', 'localhost');
        var data = JSON.stringify(model);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=archivedfilecomment", data)
            .pipe(map(  
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
          ) );
    }

    // Role Type - Plan Type mapping (admin page below Application Access)
    GetRolePlanTypeMappings(): Observable<RolePlanTypeMappingData[]> {
        let localfiscalyear = localStorage.getItem("fiscalyear") ? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<RolePlanTypeMappingData[]>(this.baseurl + "getdatas?fiscalyear=" + localfiscalyear + "&resourcename=getroleplantypemappings")
            .pipe(map(response => {
                // This endpoint returns the mapping list directly (not wrapped in a Result property).
                return response;
            }));
    }
    AddRolePlanTypeMapping(model: RolePlanTypeMappingData): Observable<any> {
        var data = JSON.stringify([model]);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=addroleplantypemapping&fiscalyear=" + this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    UpdateRolePlanTypeMapping(model: RolePlanTypeMappingData): Observable<any> {
        var data = JSON.stringify(model);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=updatesingleroleplantypemapping&fiscalyear=" + this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    DeleteRolePlanTypeMappings(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        return this.http
            .post(this.baseurl + "deletedatas?resourcename=deleteroleplantypemappings&fiscalyear=" + this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    // Role Type - Pay Curve mapping (admin page below Application Access)
    GetRolePayCurveMappings(): Observable<RolePayCurveMappingData[]> {
        let localfiscalyear = localStorage.getItem("fiscalyear") ? localStorage.getItem("fiscalyear") : environment.fiscalyear;
        return this.http
            .get<RolePayCurveMappingData[]>(this.baseurl + "getdatas?fiscalyear=" + localfiscalyear + "&resourcename=getroletypepaycurvemappings")
            .pipe(map(response => {
                // This endpoint returns the mapping list directly (not wrapped in a Result property).
                return response;
            }));
    }
    AddRolePayCurveMapping(model: RolePayCurveMappingData): Observable<any> {
        var data = JSON.stringify([model]);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=addroletypepaycurvemapping&fiscalyear=" + this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    UpdateRolePayCurveMapping(model: RolePayCurveMappingData): Observable<any> {
        var data = JSON.stringify(model);
        return this.http
            .post(this.baseurl + "postdatas?resourcename=updatesingleroletypepaycurvemapping&fiscalyear=" + this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }
    DeleteRolePayCurveMappings(model: any[]): Observable<any> {
        var data = JSON.stringify(model);
        return this.http
            .post(this.baseurl + "deletedatas?resourcename=deleteroletypepaycurvemappings&fiscalyear=" + this.localfiscalyear, data)
            .pipe(map(
                (res) => {
                    return res;
                },
                (err: any) => {
                    console.log(err);
                }
            ));
    }

}
